module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.89266734.woff";